import { useMemo } from 'react'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { RoomSession } from '../../../../../models/Room'
import { useGetUserAllocationContextUsersQuery } from '../../../../../store/media/media'
import { ASSIGNMENT_ROLE_NAME_MAPPING } from '../../MeetingSummary/ConfigureAssignment/AssignmentRoleNameMapping'
import { UserAllocationContextUser } from '../../../../../models/Allocation'

export const DEFAULT_ROLE = 'Unknown'

export const useMeetingUsers = (roomSession: RoomSession | null, identityTypes?: string[]) => {
  const accountId = useAppSelector(selectAccountId)
  const { roomId = '', id: sessionId = '' } = roomSession || {}

  const {
    data: allocation_context_users,
    isFetching,
    refetch,
  } = useGetUserAllocationContextUsersQuery({ accountId, roomId, sessionId, identityTypes }, { skip: !roomId || !sessionId, refetchOnMountOrArgChange: true })

  const usersByRoles = useMemo(() => {
    if (!allocation_context_users?.data) {
      return {}
    }

    return allocation_context_users.data.reduce((acc: { [key: string]: UserAllocationContextUser[] }, allocation_context_user) => {
      const { user } = allocation_context_user
      const roleName = !user.roles.length ? DEFAULT_ROLE : (ASSIGNMENT_ROLE_NAME_MAPPING[user.roles[0].id] ?? user.roles[0].name)

      if (!acc[roleName]) {
        acc[roleName] = []
      }
      acc[roleName].push(allocation_context_user)

      return acc
    }, {})
  }, [allocation_context_users])

  return { usersByRoles, isFetching, refetchUsers: refetch }
}
